import { FriendlyNameService } from '../../../types/PanoramaArrowIdentifier';
/**
 * Creates and return polygonal hotspot in given @{link virtualTour}.
 * @param points that the polygonal hotspot will consist of, at least 3
 * @param krpano identifies to which panorama to render the polygonal
 * @param id identifies the hotspot, if not set random id is set
 * @param modify allows modification to the created polygonal hotspot before rendering
 */
export const createPolygonalHotspot = (points, krpano, id, modify) => {
    const polygonalId = id !== null && id !== void 0 ? id : FriendlyNameService.generateRandomId();
    const polygonal = krpano.addKrpanoHotspot(polygonalId);
    modify === null || modify === void 0 ? void 0 : modify(polygonal);
    points.forEach((point, index) => {
        const polygonalPoint = polygonal.point.createItem(index);
        polygonalPoint.ath = point.xAxis;
        polygonalPoint.atv = point.yAxis;
    });
    return polygonal;
};
